// extracted by mini-css-extract-plugin
export default {"dataTable":"styles_dataTable__Bystk","dataTableFooter":"styles_dataTableFooter__1pFM6","actionIcons":"styles_actionIcons__yOSx7","form":"styles_form__5rbbr"};